// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1ssgx","content":"GlobalSearch_content__38cBg"};